import { FiCalendar, FiArrowRight } from 'react-icons/fi';

const PlanningWindowCard = ({ assignmentData }) => {
    if (!assignmentData || !assignmentData.metadata || !assignmentData.metadata.planning_window) {
        return null;
    }

    const { planning_window, timezone } = assignmentData.metadata;
    const { start, end } = planning_window;

    const formatTime = (isoString) => {
        try {
            if (!isoString) return 'N/A';
            const date = new Date(isoString);
            return date.toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                timeZone: timezone || 'UTC'
            });
        } catch (e) {
            console.error('Error formatting time:', e);
            return isoString;
        }
    };

    return (
        <div className="flex shrink-0 items-center gap-1.5 bg-main-primary/5 border border-main-primary/10 rounded-md px-2.5 py-1 text-[11px] font-semibold text-gray-500">
            <FiCalendar className="text-main-primary" size={11} />
            <span>{formatTime(start)}</span>
            <FiArrowRight size={9} className="text-gray-300" />
            <span>{formatTime(end)}</span>
        </div>
    );
};

export default PlanningWindowCard;
